/*==========================================================
MAIN NAV SCRIPTS
==========================================================*/

// Options
const mainNavTrigger = 'click', // 'click' or 'hover'
    dropdownToggleClass = 'sfHover'; // same class as superfish for CSS consistency between different trigger types

// Elements
let $nav = $('#nav'),
    $navItem = $nav.find('li'),
    $navLink = $navItem.find('a');

$(function () {
    mainNavClick();

    // Configure main nav trigger
    if (mainNavTrigger == 'hover') {
        mainNavHover();
    }

    // Mobile Nav Trigger
    const triggers = $('.menuTrigger');

    triggers.on('click', function (e) {
        e.preventDefault();
        e.stopPropagation();

        triggers.attr('aria-expanded', $(this).attr('aria-expanded') === 'false' ? 'true' : 'false');
        $('#mainNav').toggleClass('open').attr('aria-hidden', $(this).attr('aria-expanded') === 'true' ? 'false' : 'true');

        if ($(this).attr('aria-expanded') === 'true') {
            $('.mainNavBackdrop').fadeIn();
            $('body').css('overflow', 'hidden');
            trap_focus($('#mainNav'), 'mainNav_focus');
        } else {
            $('.mainNavBackdrop').fadeOut();
            $('body').css('overflow', '');
            remove_trap_focus($('#mainNav'), 'mainNav_focus');
        }
    });

    $('.mainNavBackdrop').on('click', function () {
        closeMainNav();
    })

    $(document).keydown(function (event) {
        if (event.keyCode == 27 && $('#mainNav').is(':visible')) { // Esc
            closeMainNav();
        }
    });

    function closeMainNav() {
        $('.menuTrigger').attr('aria-expanded', 'false');
        $('#mainNav').removeClass('open').attr('aria-hidden', 'true');
        $('.mainNavBackdrop').fadeOut();
        $('body').css('overflow', '');
        remove_trap_focus($('#mainNav'), 'mainNav_focus');
    }

    function mainNavClick() {
        $nav.addClass('nav--click');

        $.fn.slideToggleBool = function (bool, options) {
            return bool ? $(this).slideDown(options) : $(this).slideUp(options);
        }

        function navCloseDropdown() {
            $navItem.find('.dropDownContainer').slideToggleBool(false, 300).parent('li').removeClass(dropdownToggleClass).find('*[aria-expanded="true"]').attr('aria-expanded', false);
        }

        function navClickDropdown(bindClick) {
            if ($navLink.length > 0 && $navLink.is('.hasChildren')) {
                $navLink.each(function (index) {
                    let me = $(this),
                        $currentDD = me.next('.dropDownContainer');

                    if ($currentDD.length > 0) {
                        let dropdownID = $currentDD.attr('id') ? $currentDD.attr('id') : 'navItemDropdown' + index;

                        $currentDD.attr('id', dropdownID);

                        me.attr({
                            'role': 'button',
                            'aria-controls': dropdownID,
                            'aria-expanded': false,
                            'aria-haspopup': true
                        });
                    }

                    if (bindClick) {
                        me.click(function (event) {
                            let currentToggle = $(this),
                                parentLi = currentToggle.parents('li');

                            if (currentToggle.attr('role') || currentToggle.is('button')) {
                                event.preventDefault();
                                event.stopPropagation();
                            }

                            $('#nav li').removeClass('current');
                            parentLi.addClass('current');

                            let wasOpen = currentToggle.closest('li').find('.dropDownContainer').is(':visible');

                            // Close all dropdowns except the current dd row
                            if (!(currentToggle.closest('li').closest('.dropdown').length > 0)) {
                                // level 1
                                $('#nav > li > .dropDownContainer').slideToggleBool(false, 300).closest('li').removeClass(dropdownToggleClass).find('> [aria-expanded="true"]').attr('aria-expanded', 'false');
                            } else {
                                // level 2
                                $navItem.find('.dropDownContainer').not(currentToggle.closest('#nav').find('>li.current >.dropDownContainer')).slideToggleBool(false, 300).closest('li').removeClass(dropdownToggleClass).find('> [aria-expanded="true"]').attr('aria-expanded', 'false');
                            }

                            // Open clicked dropdown if it wasn't just closed
                            if (!wasOpen) {
                                currentToggle.closest('li').toggleClass(dropdownToggleClass);
                                currentToggle.closest('li').find('> .dropDownContainer').slideToggleBool(true, 300);
                                currentToggle.attr('aria-expanded', ($currentDD.is(':visible') ? true : false));
                            }
                        });
                    }
                })
            }
        }

        navClickDropdown(true);

        //debounce resize instead of standard resize
        $(window).debounceResize(function () {
            navCloseDropdown();
            navClickDropdown();
        });

        // Close dropdown if clicked outside of it
        $(document).on('click', function (event) {
            if (!$(event.target).closest('.dropDownContainer:visible').length) {
                navCloseDropdown();
            }
        });
    }

    function mainNavHover() {
        $.getScript('https://js.esolutionsgroup.ca/js/libs/hover-intent/1.8.0/jquery.hoverIntent.min.js', function () {
            $.getScript('https://js.esolutionsgroup.ca/js/libs/jquery_superfish/1.7.4/superfish.min.js', function () {
                $nav.addClass('nav--hover');
                mainNavHoverFn();
            });
        });
    }

    function mainNavHoverFn() {
        if (window.matchMedia('(max-width: 991px)').matches) {
            $nav.superfish('destroy');
        } else {
            $navItem.removeClass('mobile-open');
            $nav.superfish({
                cssArrows: false,
                speed: 'normal',
                speedOut: 'fast'
            });
        }

        //debounce resize instead of standard resize
        $(window).debounceResize(function () {
            mainNavHoverFn();
        });
    }
});